import type { Ref } from 'react'

import { Tag } from '@/components/tag/Tag'
import { MatterType, type MatterRead } from '@/matter/store/schemas'

type MatterHeaderProps = {
  matter: MatterRead
  /** Observed by the page header, which takes over the matter name once this scrolls out of view. */
  containerRef?: Ref<HTMLDivElement>
}

export function MatterHeader({ matter, containerRef }: MatterHeaderProps) {
  const isSampleMatter = matter.type === MatterType.SAMPLE

  return (
    <div ref={containerRef} className="flex flex-col gap-1 pb-3">
      <div className="flex items-center gap-2">
        <h1 className="min-w-0 break-words text-xl font-semibold leading-7 text-brand-neutral-900">{matter.name}</h1>
        {isSampleMatter && (
          <Tag variant="tonal" color="Green" size="xs">
            Sample Matter
          </Tag>
        )}
      </div>
      {matter.client && <p className="break-words text-base font-medium leading-6 text-brand-neutral-700">{matter.client}</p>}
    </div>
  )
}
